import { render, staticRenderFns } from "./CouponReceive.vue?vue&type=template&id=0c8cc0d0&scoped=true&"
import script from "./CouponReceive.vue?vue&type=script&lang=js&"
export * from "./CouponReceive.vue?vue&type=script&lang=js&"
import style0 from "./CouponReceive.vue?vue&type=style&index=0&id=0c8cc0d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8cc0d0",
  null
  
)

export default component.exports